import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { OndernemingService } from '../../services/onderneming.service';
import { HolidayValueService } from '../../services/Holiday-value.service';
import { DataService } from '../../services/data.service';
import { HolidayValue } from '../../models/HolidayValue';
import { IFormGroup, IFormBuilder } from '@rxweb/types';
import { Subject, throwError } from 'rxjs';
import { Onderneming } from '../../models/Onderneming';
import { takeUntil } from 'rxjs/operators';
interface UurloonForm {
  uurloon: number | null;
  aantalUren: number | null;
}
interface BrutoloonForm {
  brutoloon: number | null;
  aantalDagen: number | null;
}
@Component({
  selector: 'app-holiday-value',
  templateUrl: './holiday-value.component.html',
  styleUrls: ['./holiday-value.component.scss']
})
export class HolidayValueComponent implements OnInit {
  // Boolean voor het vertonen van de uitkomst
  calculateBruto = false;
  calculateUur = false;

  onderneming: Onderneming;
  holidayValue: HolidayValue;
  resultBruto: number = 0;
  resultUur: number = 0;

  componentDestoryed$: Subject<boolean> = new Subject();

  //form variabelen
  formBuilder: IFormBuilder;
  uurloonFormGroup: IFormGroup<UurloonForm>;
  brutoloonFormGroup: IFormGroup<BrutoloonForm>;

  constructor(
    formBuilder: FormBuilder,
    private holidayValueService: HolidayValueService,
    public dataService: DataService,
    private cd: ChangeDetectorRef,
  ) { this.formBuilder = formBuilder; }

  ngOnInit(): void {
    // Aanmaken van form
    this.uurloonFormGroup = this.formBuilder.group<UurloonForm>({
      uurloon: this.formBuilder.control(null, [Validators.required, Validators.min(0)]),
      aantalUren: this.formBuilder.control(null, [Validators.required, Validators.min(0)]),
    });

    this.brutoloonFormGroup = this.formBuilder.group<BrutoloonForm>({
      brutoloon: this.formBuilder.control(null, [Validators.required, Validators.min(0)]),
      aantalDagen: this.formBuilder.control(null, [Validators.required, Validators.min(0)]),
    });
    this.loadData();
  }
  loadData() {
    // //neem ondernemingsnaam uit het path.

    // //Als dataservice leeg is, of het is een andere onderneming, subscribe op ondernemingservice en zoek de bijhorden 
    // if (this.dataService.onderneming === undefined ||
    //   this.dataService.onderneming.naam.toLowerCase() !== this.ondernemingNaam.toLowerCase()) {

    //   this.ondernemingService.getOnderneming(this.ondernemingNaam).pipe(

    //     mergeMap((onderneming) => {
    //       this.onderneming = onderneming;
    //       this.dataService.setOnderneming(this.onderneming);
    //       localStorage.setItem('onderneming', JSON.stringify(this.dataService.onderneming.naam));
    //       return this.holidayValueService.getHolidayValue(this.onderneming?.holidayValue);
    //     }),
    //     catchError(error => {
    //       return throwError(" ");
    //     }),
    //     takeUntil(this.componentDestoryed$),
    //   ).
    //     subscribe(e => {


    //       this.holidayValue = e;
    //       err => console.log(err);
    //     });
    // }
    // else {
    //   this.onderneming = this.dataService.getOnderneming();
    //   this.getHolidayValue(this.dataService.onderneming.holidayValue);
    // }
    this.onderneming = this.dataService.getOnderneming();
    this.getHolidayValue(this.onderneming.holidayValue);
  }



  //Wanneer de onderneming al in dataservice zit, laad de in.
  getHolidayValue(id: string) {
    if (this.dataService.holidayValue === undefined) {
      this.holidayValueService.getHolidayValue(id).pipe(
        takeUntil(this.componentDestoryed$))
        .subscribe(e => {
          this.holidayValue = e;
          this.cd.markForCheck();
        });

    }
    else {
      this.holidayValue = this.dataService.holidayValue;
    }
  }

  //Bereken voor werknemer met uurloon
  onSubmitUur() {
    this.calculateUur = true;
    this.resultUur = this.uurloonFormGroup.value.uurloon * this.uurloonFormGroup.value.aantalUren;
    
  }
  //Bereken voor werknemer met brutoloon
  onSubmitBruto() {
    this.calculateBruto = true;
    this.resultBruto = ((this.brutoloonFormGroup.value.brutoloon * 3) / 13) / this.brutoloonFormGroup.value.aantalDagen;
    
  }

  //Auto unsub
  ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }
}
